import {
  titleUI,
  descriptionUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  individualUnemployabilityDescription,
  individualUnemployabilityHint,
} from '../../content/additionalBenefits';

export default {
  uiSchema: {
    ...titleUI('Individual Unemployability benefits'),
    ...descriptionUI(individualUnemployabilityDescription),
    'view:unemployable': yesNoUI({
      title:
        'Does your condition or disability prevent you from keeping a job that you could otherwise do?',
      hint: individualUnemployabilityHint,
    }),
  },
  schema: {
    type: 'object',
    properties: {
      'view:unemployable': { type: 'boolean' },
    },
  },
};
